import debounce from 'lodash/debounce';
import { createDecorator } from 'vue-class-component';

export default function Debounce(delay = 500) {
  return createDecorator((options, key) => {
    if (!options.methods) throw new Error('Must be used in methods.');

    const originalMethod = options.methods[key];

    // eslint-disable-next-line no-param-reassign
    options.methods[key] = debounce(function wrapperFn(this: Vue, ...args) {
      originalMethod.apply(this, args);
    }, delay);
  });
}
